// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3NS6D","label":"SetPasswdForm_label__3Ridw"};